import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import type { CommonCodeItem } from "src/types/common/commonCodeTypes";

type Props = {
  list: CommonCodeItem[];
  onEdit: (item: CommonCodeItem) => void;
  onDelete: (item: CommonCodeItem) => void;
};

export default function CommonCodeListTable({ list, onEdit, onDelete }: Props) {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{ border: "1px solid", borderColor: "divider" }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 900, width: 90 }}>codeId</TableCell>
            <TableCell sx={{ fontWeight: 900, width: 120 }}>grpCode</TableCell>
            <TableCell sx={{ fontWeight: 900, width: 180 }}>code</TableCell>
            <TableCell sx={{ fontWeight: 900 }}>codeName</TableCell>
            <TableCell sx={{ fontWeight: 900 }}>description</TableCell>
            <TableCell sx={{ fontWeight: 900, width: 90 }}>order</TableCell>
            <TableCell sx={{ fontWeight: 900, width: 80 }}>useYn</TableCell>
            <TableCell sx={{ fontWeight: 900, width: 170 }}>관리</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {list.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8}>
                <Typography sx={{ py: 3, textAlign: "center", color: "text.secondary" }}>
                  데이터가 없습니다.
                </Typography>
              </TableCell>
            </TableRow>
          ) : null}

          {list.map((r) => (
            <TableRow key={r.codeId} hover>
              <TableCell>{r.codeId}</TableCell>
              <TableCell>{r.grpCode}</TableCell>
              <TableCell>{r.code}</TableCell>
              <TableCell>{r.codeName}</TableCell>
              <TableCell>{r.description}</TableCell>
              <TableCell>{r.codeOrder}</TableCell>
              <TableCell>{r.useYn ? "Y" : "N"}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <Button size="small" variant="outlined" onClick={() => onEdit(r)}>
                    수정
                  </Button>
                  <Button size="small" variant="outlined" color="error" onClick={() => onDelete(r)}>
                    삭제
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
